var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',_vm._b({attrs:{"variant":"top","closeButton":""},on:{"close":function($event){return _vm.$emit('close')}}},'Modal',_vm.$attrs,false),[_c('div',{staticClass:"prompt-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }